import { render, staticRenderFns } from "./select-language.component.vue?vue&type=template&id=28c51fdf&scoped=true&"
import script from "./select-language.component.vue?vue&type=script&lang=ts&"
export * from "./select-language.component.vue?vue&type=script&lang=ts&"
import style0 from "./select-language.component.vue?vue&type=style&index=0&id=28c51fdf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c51fdf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
